import { render, staticRenderFns } from "./ZFooter.vue?vue&type=template&id=657dd1c9&"
import script from "./ZFooter.vue?vue&type=script&lang=js&"
export * from "./ZFooter.vue?vue&type=script&lang=js&"
import style0 from "./ZFooter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports